import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { NativeDateAdapter } from '@angular/material/core';

export function dateRangeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);  // Reset time for today

    const maxDate = new Date();
    maxDate.setDate(today.getDate() + 60);  // Allow max 60 days ahead
    maxDate.setHours(23, 59, 59, 999);  // End of the day

    const inputDate = new Date(control.value);

    // Ensure input date is within the valid range
    if (inputDate < today || inputDate > maxDate) {
      return { dateOutOfRange: true };
    }
    return null;
  };
}

export function pastDateValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value;

    if (!value) return null; // Let required validator handle empty case

    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time for strict comparison

    const inputDate = new Date(value);
    inputDate.setHours(0, 0, 0, 0);

    if (inputDate > today) {
      return { invalidFutureDate: true };
    }

    return null;
  };
}

export function noGarbageDateValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const val = control.value;
    if (!val) return null;

    // Reject if date is invalid or future
    const parsedDate = new Date(val);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (isNaN(parsedDate.getTime()) || parsedDate > today) {
      return { invalidDate: true };
    }
    return null;
  };
}

export function customEmailValidator(control: AbstractControl): ValidationErrors | null {
  const value = control.value;
  const emailRegex = /^.+@.+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(value) ? null : { invalidEmail: true };
}

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  override format(date: Date, displayFormat: Object): string {
    if (!date) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  override parse(value: any): Date | null {
    if (!value || typeof value !== 'string') return null;

    // Support both dd-MM-yyyy and dd/MM/yyyy
    const parts = value.trim().includes('-') ? value.trim().split('-') : value.trim().split('/');
    if (parts.length !== 3) return null;

    const [dd, mm, yyyy] = parts.map(Number);
    const parsed = new Date(yyyy, mm - 1, dd);

    // Reject invalid dates like 31/04/2025
    if (
      parsed.getFullYear() !== yyyy ||
      parsed.getMonth() !== mm - 1 ||
      parsed.getDate() !== dd
    ) {
      return null;
    }

    return parsed;
  }

}


